import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPurchaseOrderInvoiceByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getPurchaseOrderInvoiceById = createAsyncThunk('getPurchaseOrderInvoiceById', async (payload) => {
  // console.log('payload', payload);
  return await getPurchaseOrderInvoiceByIdApi(payload);
});

const getPurchaseOrderInvoiceByIdSlice = createSlice({
  name: 'getPurchaseOrderInvoiceById', // Unique Name
  initialState,
  reducers: {
    getPurchaseOrderInvoiceByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderInvoiceById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getPurchaseOrderInvoiceById.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = action.payload;
      })
      .addCase(getPurchaseOrderInvoiceById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getPurchaseOrderInvoiceByIdReset } = getPurchaseOrderInvoiceByIdSlice.actions;

export default getPurchaseOrderInvoiceByIdSlice.reducer;
